import { Button, ButtonColors } from '@chiroup/components/Button';
import { InfoItemHtml } from '@chiroup/components/InfoItemHtml';
import { OpenClosedStates } from '@chiroup/core/enums/OpenClosedStates.enum';
import { ErrorResponse } from '@chiroup/core/types/ErrorResponse.type';
import { MarketingCampaignDetail } from '@chiroup/core/types/MarketingCampaign.type';
import { useEditSlideOverState } from '@chiroup/hooks/useEditSlideOverState';
import React, { useState } from 'react';
import { UseMutateFunction } from 'react-query';
import { Link, useNavigate } from 'react-router-dom';
import { useAdminPermissions } from '../../../../hooks/useAdminPermissions';
import InfoItem from '../../../common/info/InfoItem';
import SectionContainer from '../../../layout/SectionContainer';
import SectionHeader from '../../../layout/SectionHeader';
import MarketingDeleteModal from './MarketingDeleteModal';
import MarketingGeneralEditPanel from './MarketingGeneralEditPanel';

type Props = {
  marketing: Partial<MarketingCampaignDetail>;
  save: UseMutateFunction<
    Partial<MarketingCampaignDetail>,
    ErrorResponse,
    Partial<MarketingCampaignDetail>,
    unknown
  >;
  del: () => Promise<void>;
};

const MarketingGeneral: React.FC<Props> = ({ marketing, save, del }) => {
  const navigate = useNavigate();
  const { hasPermission } = useAdminPermissions();
  const [deleteModalState, setDeleteModalState] = useState<OpenClosedStates>(
    OpenClosedStates.Closed
  );
  const [editSlideOverState, setEditSlideOverState] = useEditSlideOverState();

  const updateSlideOverState = (val: OpenClosedStates) => {
    navigate(`/practice-resources/marketing-campaigns/${marketing.ID}`);
  };

  return (
    <>
      <SectionContainer className="sm:shadow border border-gray-300 dark:border-dark-gray-800">
        <SectionHeader
          title="General"
          subtitle="General information about the marketing."
          rightSide={
            <div className="flex flex-row items-center space-x-2.5">
              {hasPermission('practice_resources.edit') && (
                <Link to="?open=edit" className="hidden sm:block">
                  <Button text="Edit" color={ButtonColors.plainWithBorder} />
                </Link>
              )}
            </div>
          }
        />
        <div className="px-4 py-5 sm:px-6">
          <dl className="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
            <InfoItem label="Type" value={marketing.type} />
            <InfoItem label="URL" value={marketing.url} />
            <InfoItem label="Description" value={marketing.descr} className="sm:col-span-2" />
            <InfoItemHtml
              className="sm:col-span-2"
              label="Implementation protocol"
              value={marketing.ImplementationProtocol || ''}
            />
          </dl>
        </div>
      </SectionContainer>
      <MarketingGeneralEditPanel
        editSlideOverState={editSlideOverState}
        updateSlideOverState={updateSlideOverState}
        defaultValues={marketing}
        save={save}
      />
      {marketing.ID && (
        <MarketingDeleteModal state={deleteModalState} setState={setDeleteModalState} del={del} />
      )}
    </>
  );
};

export default MarketingGeneral;
